import React from 'react';

import {Button, InputNumber, ModalPopup} from '@kit';

import {useCharacter} from '../character-context';
import type {SheetOverrides} from '../model/character-state';
import {DeathSavesPanel} from './death-saves';
import {HealDamageForm} from './heal-damage-form';
import {useWideScreen} from './use-wide-screen';
import {HitDice} from './hit-dice';

import css from './sheet.module.css';

type Props = {
	onClose(): void;
};

export const HitPointsModal: React.FC<Props> = ({onClose}) => {
	const {state, character, update} = useCharacter();
	const isWide = useWideScreen();
	const {maxHitPoints, maxHitPointsBonus} = state.overrides;

	const setOverride = (patch: Partial<SheetOverrides>) =>
		update((current) => ({overrides: {...current.overrides, ...patch}}));

	return (
		<ModalPopup open onClose={onClose} header="Управление ПЗ" maxWidth={480}>
			{character.currentHitPoints === 0 && <DeathSavesPanel />}
			{!isWide && (
				<div className={css.hitPointsModalQuick}>
					<HealDamageForm />
					<dl className={css.healthStats}>
						<HitDice />
					</dl>
				</div>
			)}
			<form
				className={css.formRows}
				onSubmit={(event) => {
					event.preventDefault();
					onClose();
				}}
			>
				<InputNumber
					label="Текущие ПЗ"
					min={0}
					value={character.currentHitPoints}
					onChange={(value) =>
						update((current) => ({
							hitPoints: {
								...current.hitPoints,
								spent: Math.max(0, character.maxHitPoints - Math.max(0, value || 0)),
							},
						}))
					}
				/>
				<InputNumber
					label="Временные ПЗ"
					min={0}
					value={character.currentTemporaryHitPoints}
					onChange={(value) =>
						update((current) => ({
							hitPoints: {
								...current.hitPoints,
								temporary: Math.max(0, value || 0),
								temporarySpent: 0,
							},
						}))
					}
				/>
				<InputNumber
					label="Бонус к максимуму ПЗ"
					min={0}
					placeholder="0"
					value={maxHitPointsBonus ?? null}
					onChange={(value) => setOverride({maxHitPointsBonus: value ? Math.max(0, value) : undefined})}
				/>
				<InputNumber
					label="Максимум ПЗ"
					min={1}
					placeholder={String(character.calculatedMaxHitPoints)}
					value={maxHitPoints ?? null}
					onChange={(value) => setOverride({maxHitPoints: value ? Math.max(1, value) : undefined})}
				/>
				<button type="submit" hidden />
			</form>
			<p className={css.muted}>
				Расчётный максимум: {character.calculatedMaxHitPoints}. Бонус и замена максимума действуют до долгого
				отдыха.
			</p>
			<div className={css.modalButtons}>
				{(maxHitPoints != null || maxHitPointsBonus != null) && (
					<Button
						appearance="subtle"
						onClick={() => setOverride({maxHitPoints: undefined, maxHitPointsBonus: undefined})}
					>
						Сбросить максимум
					</Button>
				)}
				<Button appearance="primary" onClick={onClose}>
					Готово
				</Button>
			</div>
		</ModalPopup>
	);
};
